import i18n from './tick-unit.properties';

/**
 * Possible units to specify steps in which to step through the temporal data. The values are
 * directly usable as keys for a date-fns {@link Duration}.
 *
 * Corresponding JavaScript "enum":
 * {@link {import('cadenza/conditions/date-time-condition/date-time-condition/TickUnit}}
 * Corresponding Java enum: net.disy.cadenza.workbook.resolving.condition.TickUnit
 */
export type TickUnit = 'years' | 'months' | 'weeks' | 'days' | 'hours' | 'minutes' | 'seconds';

export function unitLabel (unit: TickUnit, plural = false, shortFormat = false) {
  if (shortFormat) {
    return i18n(`shortTickUnit.${unit}`);
  }
  return i18n(`tickUnit.${unit}.${plural ? 'plural' : 'singular'}`);
}
